import React, { ReactElement } from 'react';
import { Message } from 'slovlex-idsk-react-components';
import './forbiddenPage.scss';
import { Heading } from 'idsk-react-components';

interface Props {
  message?: string;
  onClear?: () => void;
}

const ForbiddenPage = ({
  message = 'Nemáte oprávnenie na vykonávanie požadovanej akcie.',
  onClear,
}: Props): ReactElement => (
  <>
    <Message
      onClear={onClear}
      className="forbidden-error-message"
      type="error"
    >
      <Heading
        className="client-error-message__heading"
        size="m"
      >{message}
      </Heading>
    </Message>
  </>
);

export default ForbiddenPage;
